<template>
    <div class="flow-item-divider" :class="{ 'flow-item-divider-lighter': lighter }">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="flow-item-divider-svg">
            <!--<path d="M 40,50 10,90 10,10 z" />-->
            <path d="M 10,50 40,10 40,90 z" />
        </svg>
    </div>
</template>

<script>
    export default {
        name: 'FlowItemDivider',
        props: {
            lighter: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>
    .flow-item-divider {
        flex-shrink: 1;
        height: 100%;
        padding-left: 20px;
        padding-right: 20px;
    }

    .flow-item-divider-svg {
        width: 50px;
        height: 100px;
    }

    .flow-item-divider path {
        stroke-width: 20;
        stroke-linejoin: round;
        stroke-linecap: round;
        stroke: rgb(var(--v-theme-darkerbase));
        fill: rgb(var(--v-theme-darkerbase));
    }

    .flow-item-divider-lighter path {
        stroke: rgb(var(--v-theme-darkerbase));
        fill: rgb(var(--v-theme-darkerbase));
    }

    @media (max-width: 2000px) {
        .flow-item-divider {
            transform: scale(0.9);
        }
    }

    @media (max-width: 1700px) {
        .flow-item-divider {
            transform: scale(0.8);
        }

        .flow-item-divider {
            padding-left: 15px;
            padding-right: 15px;
        }
    }

    @media (max-width: 1400px) {
        .flow-item-divider {
            transform: scale(0.7);
        }

        .flow-item-divider {
            padding-left: 10px;
            padding-right: 10px;
        }
    }

    @media (max-width: 1000px) {
        .flow-item-divider {
            transform: scale(0.6);
        }
    }

    @media (max-width: 800px) {
        .flow-item-divider {
            transform: scale(0.5);
            max-width: 30px;
        }

        .flow-item-divider {
            padding-left: 5px;
            padding-right: 5px;
        }
    }

    @media (max-width: 600px) {
        .flow-item-divider {
            transform: scale(0.35);
        }
    }
</style>